import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { ConfigurationService } from '@draeger-academy/common';

@Component({
    selector: 'da-content-section',
    templateUrl: './content-section.component.html',
    styleUrls: ['./content-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentSectionComponent implements OnInit {
    @Input() data;
    @Input() specialData?: { allowAnchor: boolean };
    @Input() allowAnchor: boolean;

    @HostBinding('class') public className: string;
    private _showMore = false;

    constructor(private _configurationService: ConfigurationService) {}

    public get numberOfVisibleBoxes(): number {
        return this.data._options.visibleBoxes &&
            this.data._options.visibleBoxes > 0 &&
            this.data.boxes.length > this.data._options.visibleBoxes
            ? this.data._options.visibleBoxes
            : 0;
    }

    ngOnInit() {
        if (this.specialData && typeof this.specialData.allowAnchor === 'boolean') {
            this.allowAnchor = this.specialData.allowAnchor;
        }

        this.className = this.data ? this.data._options.background : '';
    }

    public toggleShowMore(e: boolean): void {
        this._showMore = e;
    }
}
